/**
 * @generated SignedSource<<52e189ccd1d091965eed27bb5c782c1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DietaryTags = "ALCOHOL_FREE" | "ALLERGY" | "ALLIUM" | "CRUSTACEAN" | "DAIRY_FREE" | "DIABETIC" | "EGGS" | "FISH" | "GARLIC" | "GLUTEN_FREE" | "HAZELNUT" | "KOSHER" | "MILK" | "MUSHROOMS" | "NIGHTSHADE" | "NUTS" | "PALEO" | "PEANUTS" | "PESCATARIAN" | "PORK" | "POULTRY" | "PREGNANT" | "RED_MEAT" | "SALT" | "SEAFOOD" | "SHELLFISH" | "SHRIMP" | "SOY" | "SULFITES" | "TOMATOES" | "TREE_NUTS" | "VEGAN" | "VEGETARIAN" | "WALNUTS" | "WHEAT";
export type OccasionTags = "ANNIVERSARY" | "BIRTHDAY" | "BUSINESS_MEETING" | "CELEBRATION" | "CORPORATE_EVENT" | "GRADUATION" | "SPECIAL_EVENT";
import { FragmentRefs } from "relay-runtime";
export type DiningSpecialRequestsSection_booking$data = {
  readonly canUpdate?: boolean | null | undefined;
  readonly dietaryTags?: ReadonlyArray<DietaryTags> | null | undefined;
  readonly id?: string;
  readonly notesFromMember?: string | null | undefined;
  readonly occasionTags?: ReadonlyArray<OccasionTags> | null | undefined;
  readonly ownerClient?: {
    readonly __typename: "Customer";
    readonly id: string;
  } | {
    readonly __typename: "Member";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly rounds?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly player: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot?: {
    readonly agenda: {
      readonly facility: {
        readonly diningDietaryTags: ReadonlyArray<DietaryTags> | null | undefined;
        readonly diningOccasionTags: ReadonlyArray<OccasionTags> | null | undefined;
      };
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DiningSpecialRequestsModal_booking">;
  readonly " $fragmentType": "DiningSpecialRequestsSection_booking";
};
export type DiningSpecialRequestsSection_booking$key = {
  readonly " $data"?: DiningSpecialRequestsSection_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiningSpecialRequestsSection_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiningSpecialRequestsSection_booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiningSpecialRequestsModal_booking"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canUpdate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dietaryTags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "occasionTags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notesFromMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "startSlot",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agenda",
              "kind": "LinkedField",
              "name": "agenda",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "diningDietaryTags",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "diningOccasionTags",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "ownerClient",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundConnection",
          "kind": "LinkedField",
          "name": "rounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoundEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "player",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "104357c874e94a33ad91cd510f27c10f";

export default node;
